export default __webpack_public_path__ + "static/media/user--3.5323a381.jpg";